import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  categorieList: [],
}
const groupSlice = createSlice({
  name: 'dataCategories',
  initialState,
  reducers: {
    getAllCategories(state, action) {
      return { ...state, categorieList: action.payload.data }
    },
  },
})

export default groupSlice
